/**
 * Network-tab hooks: the per-agent sandbox egress policy read and its update.
 */

import { hubQueryKeys, type NetworkEgressConfig } from "@lifter/hub-ui/browser-shared";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { type AgentQueryOptions, useHubApi } from "./context";

export function useNetworkEgressQuery(agentId: string, options: AgentQueryOptions = {}) {
  const api = useHubApi();
  return useQuery({
    queryKey: hubQueryKeys.networkEgress(agentId),
    queryFn: () => api.networkEgress.get(agentId),
    enabled: options.enabled ?? true,
    refetchInterval: 15_000,
  });
}

export function useUpdateNetworkEgressMutation(agentId: string) {
  const api = useHubApi();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (config: NetworkEgressConfig) => api.networkEgress.update(agentId, config),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: hubQueryKeys.networkEgress(agentId) });
    },
  });
}
